import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";

export const taskRemoveTagMutation = ({
  taskId,
  flag,
}: {
  taskId: string
  flag: string
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/tasks/${taskId}/removeTags?tag=${flag}`,
    codec: t.unknown,
  })